import { DocumentIdentity } from '@dealstack/frontend/shared/components/Documents/types';
import { DocumentsRes } from '@dealstack/shared/lib/generated';

export type DocumentsLibraryDocumentRes = DocumentsRes['documents'][0];

export type SelectedDocument = DocumentIdentity;

export enum DocumentLibraryFields {
	documentTitle = 'documentTitle',
	classifiers = 'classifiers',
	fileName = 'fileName',
	uploadDate = 'uploadDate',
	totalAssociatedLinks = 'totalAssociatedLinks',
}

export type DocumentLibraryDetails = {
	documentId: string;
	documentTitle: string;
	classifiers: string[];
	fileName: string;
	uploadDate: Date;
	totalAssociatedLinks: string;
};

export enum RightPanelAction {
	BULK_CLASSIFY = 'BULK_CLASSIFY',
	NONE = 'NONE',
	EDIT_DOCUMENT = 'EDIT_DOCUMENT',
	ARCHIVE_DOCUMENT = 'ARCHIVE_DOCUMENT',
	BULK_ADD_PERSONS = 'BULK_ADD_PERSONS',
}
